import { getLanguageFromStorage, getQueryParam } from 'syf-js-utilities';
import useConfig from '../context/config.context';
const useCardAccessLink = () => {
    var _a, _b, _c;
    const client = ((_a = localStorage.getItem('client')) === null || _a === void 0 ? void 0 : _a.toLowerCase()) ||
        ((_b = getQueryParam('client')) === null || _b === void 0 ? void 0 : _b.toLowerCase()) ||
        '';
    const currentLang = getLanguageFromStorage();
    const { config } = useConfig();
    const serviceFilePathname = config === null || config === void 0 ? void 0 : config.hosts.serviceFile.pathname;
    const environment = serviceFilePathname.match(/\/prod-disputes-config/)
        ? 'prod'
        : 'non-prod';
    const urlMap = {
        'non-prod': {
            belk: `https://uaccounts.syf.com/?c=belk&l=${currentLang}&excl=y&o=rep_vista`,
            lowes: `https://uaccounts.syf.com/?c=lowes&l=${currentLang}&excl=y&o=rep_vista`,
            tru: `https://uaccounts.syf.com/?c=tru&l=${currentLang}&excl=y&o=rep_vista`,
            verizon: `https://uaccounts.syf.com/?c=verizon&l=${currentLang}&excl=y&o=rep_vista`,
            aeoutfitters: `https://uaccounts.syf.com/?c=aeoutfitters&l=${currentLang}&excl=y&o=rep_vista`,
            athome: `https://uaccounts.syf.com/?c=athome&l=${currentLang}&excl=y&o=rep_vista`,
            virgin: `https://uaccounts.syf.com/?c=virgin&l=${currentLang}&excl=y&o=rep_vista`
        },
        prod: {
            belk: `https://accounts.syf.com/?c=belk&l=${currentLang}&o=rep_vista`,
            lowes: `https://accounts.syf.com/?c=lowes&l=${currentLang}&excl=y&o=rep_vista`,
            tru: `https://accounts.syf.com/?c=tru&l=${currentLang}&o=rep_vista`,
            verizon: `https://accounts.syf.com/?c=verizon&l=${currentLang}&o=rep_vista`,
            aeoutfitters: `https://accounts.syf.com/?c=aeoutfitters&l=${currentLang}&o=rep_vista`,
            athome: `https://accounts.syf.com/?c=athome&l=${currentLang}&o=rep_vista`,
            virgin: `https://accounts.syf.com/?c=virgin&l=${currentLang}&o=rep_vista`
        }
    };
    const cardAccessUrl = (_c = urlMap[environment]) === null || _c === void 0 ? void 0 : _c[client];
    return { cardAccessUrl };
};
export default useCardAccessLink;
//# sourceMappingURL=useCardAccessLink.js.map